import type { EventCardRequest, EventCardResponse } from '@/models/interface/eventCard';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class EventCardService extends ApiFactory {
  constructor() {
    super('EntranceAd');
  }

  /**
   * 取得蓋版清單
   */
  getEventCards(params: EventCardRequest): Promise<ApiDataResponse<EventCardResponse>> {
    return super.post('', params);
  }
}
